import { RhinoError } from '../../error';

export function createMissingPersonalListTypeError() {
  return new RhinoError('CONFIGURATION', 'User Personal Linup list type is not configured on Device Configuration.');
}

export function createMissingPersonalListInitError() {
  return new RhinoError(
    'RUNTIME',
    'Personal List is not defined. You must await isLoading to be resolved on usePersonalList',
  );
}
